import { AuditQuestion, KeyQuestion } from '../auditTypes';
const KQS = ['safe', 'effective', 'caring', 'responsive', 'wellled'];
export const q = (id: string, text: string, ...rest: any[]): AuditQuestion => {
  let guidance = '';
  let keyQuestion: KeyQuestion;
  let regulation: string | undefined;
  let critical: boolean | undefined;
  if (KQS.includes(rest[0])) {
    keyQuestion = rest[0];
    regulation = typeof rest[1] === 'string' ? rest[1] : undefined;
    critical = typeof rest[2] === 'boolean' ? rest[2] : (typeof rest[1] === 'boolean' ? rest[1] : undefined);
  } else {
    guidance = rest[0] || '';
    keyQuestion = rest[1];
    regulation = typeof rest[2] === 'string' ? rest[2] : undefined;
    critical = typeof rest[3] === 'boolean' ? rest[3] : undefined;
  }
  return { id, text, guidance, keyQuestion, regulation, critical };
};